import styled from 'styled-components';

import { Skeleton as UISkeleton } from '@/shared/ui/skeleton';

export const Skeleton = styled(UISkeleton)`
	min-width: 18px;

	@media ${({ theme: { media } }) => media.mobile} {
		margin-right: 12px;
	}
`;
